<!--
 Display a button with a menu on it
  The menu is filled from the passing menu-contents-function
  An index value can also be supplied. Use this to identify the
  the item the button is linked to.
  index will be passed to menu-contents-function
-->

<template>
    <button type="button"
            class="btn outline icon-button context-button"
            :class="className"
            @click="showTopMenu($event)">
        <i class="icon icon-dots-vertical IconAsButton" />
    </button>
</template>

<script setup>
    import { defineProps, ref } from 'vue';

    const props = defineProps({
        //Function called to setup the context menu
        menuContentsFunction: {
            type: Object,
            default: null
        },
        // An index number passed in
        // This is passed to the menuContentsFunction when
        // it is called to set-up the menu
        index: {
            type: Number,
            default: 0
        },
        className: {
            type: String,
            default: ""
        }
    });

    const show = ref(false);
    const option = ref({});
    const items = ref([]);

    function showTopMenu(event) {
        let items = props.menuContentsFunction(props.index);

        // The following is a global script function
        // eslint-disable-next-line
        offsetPopmenu(event, items);
    }

</script>

<style lang="scss">
    .mx-menu-ghost-host {
        z-index: 9999;
    }
</style>